import { UIText3, ArticleHeading4, LinkButton } from '@cian/ui-kit';
import * as React from 'react';
import { MORTGAGE_LINK } from '../../../../constants/mortgage';
import { mortgageLogo, banks } from '../../assets';
import * as styles from './MortgageBanner.css';

interface IMortgageBannerProps {
  onButtonClick(): void;
}

export const MortgageBanner: React.FC<IMortgageBannerProps> = ({ onButtonClick }) => {
  return (
    <div className={styles['banner']}>
      <div className={styles['banks']}>
        <img src={mortgageLogo} className={styles['mortgage-logo']} />
        <div className={styles['bank-icons']}>
          {banks.map((bankLogo, index) => (
            <div key={index} className={styles['bank-item']}>
              <img src={bankLogo} />
            </div>
          ))}
          <div className={styles['bank-item']}>
            <div className={styles['bank-counter']}>
              <UIText3>+4</UIText3>
            </div>
          </div>
        </div>
      </div>
      <div className={styles['button-container']}>
        <ArticleHeading4 textAlign="right">
          Узнайте, какую программу
          <br />
          одобрят вам
        </ArticleHeading4>
        <LinkButton target="_blank" href={MORTGAGE_LINK} theme="fill_primary" size="M" onClick={onButtonClick}>
          Подать заявку онлайн
        </LinkButton>
      </div>
    </div>
  );
};
